export default __webpack_public_path__ + "static/media/preview.2fb7fd02.jpeg";